import React, { useState, useEffect, useRef } from "react";
import { useModal } from "contexts/modalContext/modalContext.js";
import FooterPersonalPage from "./FooterPersonalPage.js";
import FormSide from "./FormSide.js";
import useOnClickOutside from "hooks/useOnClickOutside.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import EmbedLimitOptionsModal from "components/Reusable/JUMBOform/Modals/EmbedLimitOptionsModal.js";
import { UpdateEmbedPageTextAndTitle } from "../../Helpers/ApiCalles.js";
import EmbedLogoUploader from "components/Reusable/EmbedPageLogoUploader/EmbedLogoUploader.js";
import { useUser } from "contexts/userContext/userContext.js";
import LogoSide from "./LogoSide.js";
import FormEditSide from "./FormEditSide.js";
import FormPreviewSide from "./FormPreviewSide.js";
import { contains_heb } from "utils/hebrewOrArabicText.js";
import OrderTrackerScript from "components/Reusable/OrderTrackerScript/OrderTrackerScript.js";
import Image from "components/Elements/Image/Image.tsx";
import {
  faFacebookF,
  faLinkedinIn,
  faSquareInstagram,
  faSquareWhatsapp,
  faVimeoV,
  faXTwitter,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import {
  faEnvelope,
  faGlobe,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";

import config from "config.ts";

const fileReader = new FileReader();

const EditEmbedPageBody = ({
  logoImage,
  setLogoImage,
  pageMode,
  setTextPage,
  textPage,
  setTitlePage,
  titlePage,
  diractionPage,
  FullDetailsEmbedPage,
  EmbedPageFormList,
  setEmbedPageFormList,
  removeImageApi,
  removeFormImageApi,
  socialLinks,
  formImage,
  setFormImage,
  randomBackground,
  brandingColor,
  singleForm,
  randomUrlImage,
  oldEmbedPageFormList,
  setOldEmbedPageFormList,
  loadingCarousel,
  linkFooters,
  setLinkFooters,
  viewType,
  showOrderTracker,
  userFormsList,
  setUserFormsList,
  pageLanguage,
  isDemoPage = null,
  checkOrderStatusText,
  backButtonText,
  isOpen,
  demoPageId = null,
  countActiveForms,
  displayFormDetails,
  setDisplayFormDetails,
  displaySidePanel,
}) => {
  const { setModal } = useModal();
  const maxLimitTitle = 30;
  const maxLimitText = 150;
  const { isSubscribed } = useUser();
  const { getTextByKey } = useContent();
  const [selectedForm, setSelectedForm] = useState(null);
  const [newSelectedListForm, setNewSelectedListForm] = useState(null);
  const [isUpdateTitleOrDescriptionForm, setIsUpdateTitleOrDescriptionForm] =
    useState(false);

  const [hideBackButton, setHideBackButton] = useState(false);
  const [newList, setNewList] = useState([]);
  const [titleForm, setTitleForm] = useState("");
  const [descriptionForm, setDescriptionForm] = useState("");
  const [closePreviewModeHeader, setClosePreviewModeHeader] = useState(false);
  const [closePreviewDesktop, setClosePreviewDesktop] = useState(false);
  const listIcons = {
    website: faGlobe,
    youtube: faYoutube,
    twitter: faXTwitter,
    facebook: faFacebookF,
    instagram: faSquareInstagram,
    vimeo: faVimeoV,
    linkedin: faLinkedinIn,
    whatsapp: faSquareWhatsapp,
    phone: faPhone,
    email: faEnvelope,
  };
  const [textPagePlaceHolder, setTextPagePlaceHolder] = useState(
    getTextByKey("personal-page-example-text")
      ? getTextByKey("personal-page-example-text")
      : ""
  );
  const [titlePagePlaceHolder, setTitlePagePlaceHolder] = useState(
    getTextByKey("title-page-placeholder")
      ? getTextByKey("title-page-placeholder")
      : ""
  );
  const [titleFormPlaceHolder, setTitleFormPlaceHolder] = useState(
    getTextByKey("title-form-placeholder")
      ? getTextByKey("title-form-placeholder")
      : ""
  );
  const [descriptionFormPlaceHolder, setDescriptionFormPlaceHolder] = useState(
    getTextByKey("description-form-placeholder")
      ? getTextByKey("description-form-placeholder")
      : ""
  );
  useEffect(() => {
    if (FullDetailsEmbedPage) {
      getNewSocialLinks();
    }
  }, [FullDetailsEmbedPage, socialLinks]);

  useEffect(() => {
    if (pageMode !== "preview") {
      setClosePreviewDesktop(false);
      setClosePreviewModeHeader(false);
    }
  }, [pageMode]);

  useEffect(() => {
    if (textPage) {
      setTextPagePlaceHolder(null);
    } else {
      setTextPagePlaceHolder(
        getTextByKey("personal-page-example-text")
          ? getTextByKey("personal-page-example-text")
          : ""
      );
    }
  }, [textPage]);

  useEffect(() => {
    if (titlePage) {
      setTitlePagePlaceHolder(null);
    } else {
      setTitlePagePlaceHolder(
        getTextByKey("title-page-placeholder")
          ? getTextByKey("title-page-placeholder")
          : ""
      );
    }
  }, [titlePage]);

  useEffect(() => {
    if (titleForm) {
      setTitleFormPlaceHolder(null);
    } else {
      setTitleFormPlaceHolder(
        getTextByKey("title-form-placeholder")
          ? getTextByKey("title-form-placeholder")
          : ""
      );
    }
  }, [titleForm]);

  useEffect(() => {
    if (descriptionForm) {
      setDescriptionFormPlaceHolder(null);
    } else {
      setDescriptionFormPlaceHolder(
        getTextByKey("description-form-placeholder")
          ? getTextByKey("description-form-placeholder")
          : ""
      );
    }
  }, [descriptionForm]);

  const getNewSocialLinks = () => {
    let temp = socialLinks.filter((item) => item.state !== "");
    setNewList(temp);
    //EmbedPageLinkUrl
    //EmbedPageLinkSourceName
  };
  const [oldTitle, setOldTitle] = useState(
    FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageBoxTitle
      ? FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageBoxTitle
      : ""
  );
  const [oldText, setoldText] = useState(
    FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageBoxText
      ? FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageBoxText
      : ""
  );
  const [oldTitleForm, setOldTitleForm] = useState("");
  const [oldDescriptionForm, setOldDescriptionForm] = useState("");

  //const textAndTitleRef = useRef();
  const titlePageRef = useRef();
  const descriptionPageRef = useRef();
  const titleFormRef = useRef();
  const descriptionFormRef = useRef();
  const inputImageRef = useRef();

  //Update title by click outside the input
  useOnClickOutside(titlePageRef, () => {
    setTitlePage(titlePage.trim());
    if (pageMode === "edit") {
      if (FullDetailsEmbedPage) {
        if (titlePage !== oldTitle) {
          setOldTitle(titlePage.trim());
          const updateTextAndTitle = {
            EmbedDynamicPageId:
              FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageId,
            EmbedDynamicPageBoxTitle: titlePage.trim(),
            EmbedDynamicPageBoxText: textPage.trim(),
          };
          UpdateEmbedPageTextAndTitle(updateTextAndTitle);
        }
      }
    }
  });

  //Update text by click outside the input
  useOnClickOutside(descriptionPageRef, () => {
    setTextPage(textPage.trim());
    if (pageMode === "edit") {
      if (FullDetailsEmbedPage) {
        if (textPage !== oldText) {
          setoldText(textPage.trim());
          const updateTextAndTitle = {
            EmbedDynamicPageId:
              FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageId,
            EmbedDynamicPageBoxTitle: titlePage.trim(),
            EmbedDynamicPageBoxText: textPage.trim(),
          };
          UpdateEmbedPageTextAndTitle(updateTextAndTitle);
        }
      }
    }
  });

  const changeTextareaTitle = (e) => {
    if (e.length <= maxLimitTitle) {
      setTitlePage(e);
    } else {
      setTitlePage(e.substring(0, maxLimitTitle));
    }
  };

  useEffect(() => {
    if (EmbedPageFormList.length > 0) {
      const forms = EmbedPageFormList.map((item) => ({
        Embed_Dynamic_Id: item.EmbedPageFormId,
        Embed_Dynamic_Width: item.EmbedPageFormWidth,
        Embed_Dynamic_Height: item.EmbedPageFormHeight,
        Embed_Dynamic_Inner_Title: item.EmbedPageFormInnerTitle,
        Embed_Dynamic_Display_Title: item.EmbedPageFormDisplayTitle,
        Embed_Dynamic_Description: item.EmbedPageFormDescription,
        Embed_Dynamic_Image: item.EmbedPageFormImage,
      }));

      setNewSelectedListForm(forms); //set new forms list

      if (EmbedPageFormList.length === 1) {
        setSelectedForm(forms[0]); //set first selected Form
        setHideBackButton(true);
      }
    }
  }, [EmbedPageFormList]);

  useEffect(() => {
    if (selectedForm) {
      if (selectedForm.Embed_Dynamic_Image) {
        setFormImage(selectedForm.Embed_Dynamic_Image);
      } else {
        setFormImage(null);
      }

      if (selectedForm.Embed_Dynamic_Inner_Title) {
        setOldTitleForm(selectedForm.Embed_Dynamic_Inner_Title);
        setTitleForm(
          isDemoPage
            ? getTextByKey("default-title")
            : selectedForm.Embed_Dynamic_Inner_Title
        );
      } else {
        setTitleForm("");
        setOldTitleForm("");
      }

      if (selectedForm.Embed_Dynamic_Description) {
        setDescriptionForm(
          isDemoPage
            ? getTextByKey("default-description")
            : selectedForm.Embed_Dynamic_Description
        );
        setOldDescriptionForm(selectedForm.Embed_Dynamic_Description);
      } else {
        setDescriptionForm("");
        setOldDescriptionForm("");
      }
    } else {
      resetForm();
    }
  }, [selectedForm]);

  const resetForm = () => {
    setFormImage(null);
    setTitleForm("");
    setDescriptionForm("");
    setOldTitleForm("");
    setOldDescriptionForm("");
  };

  const handleNewImage = (e) => {
    if (!isSubscribed()) {
      setModal(() => <EmbedLimitOptionsModal />);
    } else {
      if (e.target.files[0]) {
        const logoName = e.target.files[0].name.replaceAll("&", "-");
        const imagePreview = URL.createObjectURL(e.target.files[0]);
        setModal(() => (
          <EmbedLogoUploader
            pcImage={true}
            LogoName={logoName}
            logoImage={imagePreview}
            setLogoImage={setLogoImage}
            removeImageApi={removeImageApi}
          />
        ));
      }
    }
  };

  useEffect(() => {
    if (!selectedForm) {
      setClosePreviewDesktop(false);
      setClosePreviewModeHeader(false);
    } else if (selectedForm && pageMode === "preview") {
      if (viewType === "desktop") {
        if (userFormsList.length === 1) {
        } else {
          setClosePreviewModeHeader(false);
          setClosePreviewDesktop(true);
        }
      } else {
        if (userFormsList.length === 1) {
        } else {
          setClosePreviewModeHeader(true);
          setClosePreviewDesktop(false);
        }
      }
    }
  }, [selectedForm, viewType]);

  useEffect(() => {
    if (viewType === "desktop") {
      setClosePreviewModeHeader(false);
    } else {
      setClosePreviewDesktop(false);
    }
  }, [viewType]);

  const openModalOrderTracker = () => {
    setModal({
      modal: OrderTrackerScript,
      modalSize: "full-modal",
      props: {
        brandingColor: brandingColor,
        isEmbedPage: true,
        isModal: true,
        isMobileView: viewType === "mobile" ? true : false,
        lang: pageLanguage,
      },
    });
  };

  return (
    <div
      className={`personal-branding-body ${
        diractionPage === "rtl" ? "right-to-left" : "left-to-right"
      }`}
    >
      <div className={`personal-body-div ${selectedForm ? "select-form" : ""}`}>
        <div
          className={`background-page ${pageMode} ${
            !selectedForm ? "carousel-background" : ""
          }`}
        >
          {randomUrlImage ? (
            <Image
              src={
                randomUrlImage.includes("https://")
                  ? randomUrlImage
                  : `${config.api.resource}/assets/images/${randomUrlImage}.webp`
              }
              title=""
              alt=""
            />
          ) : (
            <Image
              src={
                randomBackground.includes("https://")
                  ? randomBackground
                  : `${config.api.resource}/assets/images/${randomBackground}.webp`
              }
              alt=""
              title=""
            />
          )}
        </div>
        {displaySidePanel && (
          <LogoSide
            demoPageId={demoPageId}
            pageLanguage={pageLanguage}
            showOrderTracker={showOrderTracker}
            diractionPage={diractionPage}
            pageMode={pageMode}
            closePreviewModeHeader={closePreviewModeHeader}
            setClosePreviewModeHeader={setClosePreviewModeHeader}
            closePreviewDesktop={closePreviewDesktop}
            setClosePreviewDesktop={setClosePreviewDesktop}
            titlePage={titlePage}
            viewType={viewType}
            selectedForm={selectedForm}
            logoImage={logoImage}
            setLogoImage={setLogoImage}
            removeImageApi={removeImageApi}
            titlePagePlaceHolder={titlePagePlaceHolder}
            changeTextareaTitle={changeTextareaTitle}
            textPage={textPage}
            setTextPage={setTextPage}
            brandingColor={brandingColor}
            listIcons={listIcons}
            newList={newList}
            maxLimitText={maxLimitText}
            textPagePlaceHolder={textPagePlaceHolder}
            descriptionPageRef={descriptionPageRef}
            maxLimitTitle={maxLimitTitle}
            titlePageRef={titlePageRef}
            inputImageRef={inputImageRef}
            handleNewImage={handleNewImage}
            checkOrderStatusText={checkOrderStatusText}
          />
        )}
        <div
          className={`form-side ${pageMode === "edit" ? "" : "preview"} ${
            selectedForm ? "form-enter" : "carousel-mode"
          } ${closePreviewModeHeader ? "form-side-preivew-close" : ""} ${
            closePreviewDesktop ? "close-preview-desktop-form-side" : ""
          } ${diractionPage === "rtl" ? "right" : "left"} ${
            !displayFormDetails ? "hide-details" : ""
          }`}
        >
          {pageMode === "preview" && viewType === "mobile" && selectedForm && (
            <div className="background-to-mobile">
              {randomUrlImage ? (
                <Image src={randomUrlImage} title="" alt="" />
              ) : (
                <Image src={randomBackground} alt="" title="" />
              )}
            </div>
          )}
          {selectedForm && (
            <div
              className={`form-details ${
                !displayFormDetails ? "hide-details" : ""
              }`}
              style={
                {
                  // direction: contains_heb(
                  //   !closePreviewDesktop ? titleForm : getTextByKey("back-home")
                  // ),
                }
              }
            >
              {selectedForm && oldEmbedPageFormList.length > 1 && (
                <div
                  style={{
                    direction:
                      !closePreviewDesktop && titleForm
                        ? contains_heb(titleForm)
                        : diractionPage,
                  }}
                  className="back-button"
                >
                  <div
                    style={{
                      direction:
                        !closePreviewDesktop && titleForm
                          ? contains_heb(titleForm)
                          : diractionPage,
                    }}
                    className="back-button-content"
                    onClick={() => setSelectedForm(null)}
                  >
                    <Image
                      style={{
                        direction:
                          !closePreviewDesktop && titleForm
                            ? contains_heb(titleForm)
                            : diractionPage,
                      }}
                      title=""
                      alt=""
                      name="personal/back-forms"
                      ext="png"
                    />
                    <span>{backButtonText}</span>
                  </div>
                </div>
              )}
              {pageMode === "edit" ? (
                <FormEditSide
                  setEmbedPageFormList={setEmbedPageFormList}
                  EmbedPageFormList={EmbedPageFormList}
                  oldDescriptionForm={oldDescriptionForm}
                  oldTitleForm={oldTitleForm}
                  oldTitle={oldTitle}
                  setOldTitle={setOldTitle}
                  titleForm={titleForm}
                  setTitleForm={setTitleForm}
                  pageMode={pageMode}
                  titleFormRef={titleFormRef}
                  titleFormPlaceHolder={titleFormPlaceHolder}
                  selectedForm={selectedForm}
                  descriptionForm={descriptionForm}
                  setDescriptionForm={setDescriptionForm}
                  maxLimitText={maxLimitText}
                  descriptionFormPlaceHolder={descriptionFormPlaceHolder}
                  formImage={formImage}
                  setFormImage={setFormImage}
                  removeFormImageApi={removeFormImageApi}
                  descriptionFormRef={descriptionFormRef}
                  maxLimitTitle={maxLimitTitle}
                  newSelectedListForm={newSelectedListForm}
                  setNewSelectedListForm={setNewSelectedListForm}
                  userFormsList={userFormsList}
                  setUserFormsList={setUserFormsList}
                  setOldEmbedPageFormList={setOldEmbedPageFormList}
                  oldEmbedPageFormList={oldEmbedPageFormList}
                  setIsUpdateTitleOrDescriptionForm={
                    setIsUpdateTitleOrDescriptionForm
                  }
                  displayFormDetails={displayFormDetails}
                  setDisplayFormDetails={setDisplayFormDetails}
                />
              ) : (
                <FormPreviewSide
                  demoPageId={demoPageId}
                  pageMode={pageMode}
                  viewType={viewType}
                  selectedForm={selectedForm}
                  closePreviewDesktop={closePreviewDesktop}
                  titleForm={titleForm}
                  descriptionForm={descriptionForm}
                  formImage={formImage}
                />
              )}
            </div>
          )}

          <FormSide
            closePreviewModeHeader={closePreviewModeHeader}
            pageLanguage={pageLanguage}
            loadingCarousel={loadingCarousel}
            oldEmbedPageFormList={oldEmbedPageFormList}
            selectedForm={selectedForm}
            setSelectedForm={setSelectedForm}
            newSelectedListForm={newSelectedListForm}
            pageMode={pageMode}
            hideBackButton={!displayFormDetails ? false : hideBackButton}
            brandingColor={brandingColor}
            viewType={viewType}
            formImage={formImage}
            isUpdateTitleOrDescriptionForm={isUpdateTitleOrDescriptionForm}
            setIsUpdateTitleOrDescriptionForm={
              setIsUpdateTitleOrDescriptionForm
            }
            backButtonText={backButtonText}
            countActiveForms={countActiveForms}
            displayFormDetails={displayFormDetails}
          />
        </div>
        {(pageMode === "preview" &&
          viewType !== "desktop" &&
          showOrderTracker) ||
          (!displaySidePanel && showOrderTracker && (
            <div
              className={`order-tracker-icon-tablet ${
                selectedForm ? "single-form" : ""
              }`}
            >
              <div
                className={`order-tracker-text open`}
                onClick={() => openModalOrderTracker()}
              >
                <div
                  className="order-tracker-image"
                  style={{ backgroundColor: brandingColor }}
                >
                  <Image name="personal/order-tracker-icon" title="" alt="" />
                </div>
              </div>
            </div>
          ))}
      </div>
      <FooterPersonalPage
        linkFooters={linkFooters}
        setLinkFooters={setLinkFooters}
        diractionPage={diractionPage}
        pageMode={pageMode}
        FullDetailsEmbedPage={FullDetailsEmbedPage}
        isOpen={isOpen}
      />
    </div>
  );
};

export default EditEmbedPageBody;
